import { createTheme } from '@mui/material/styles'
import { alpha } from '@mui/material'

const customTypography = {
    fontFamily: "'Bebas Neue', cursive",
    letterSpacing: '0.04em',
    fontSize: '14px',
}

const basicTheme = createTheme({
    spacing: n => `${n * 10}px`,
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 769,
            lg: 1280,
            xl: 1800,
        },
    },

    palette: {
        info: {
            main: '#113AC8',
            contrastText: '#fff',
        },

        success: {
            main: '#2AC95C',
            contrastText: '#fff',
        },

        warning: {
            main: '#FF8800',
            contrastText: '#fff',
        },

        grey: {
            100: '#9499A4',
            200: '#9EA2B2',
            300: '#f3f5f8', // borders / table-borders
            400: '#A3A3A3',
            500: '#F8F9FB',
            600: '#C1C6D0',
            700: '#BBC0CB',
        },
    },
})

const theme = createTheme(basicTheme, {
    typography: {
        fontFamily: "'Inter', sans-serif",
        custom: customTypography,

        h6: {
            fontSize: '14px',
            fontWeight: '500 !important',
            lineHeight: 1,
        },

        body2: {
            fontSize: '12px',
            lineHeight: '16px',
            fontWeight: 400,
            color: basicTheme.palette.grey[100],
        },

        overline: {
            textTransform: 'uppercase',
            fontWeight: 400,
            ...customTypography,
            fontSize: '15px',
            lineHeight: 1,
            cursor: 'pointer',
        },

        caption: {
            fontSize: '12px',
            textTransform: 'uppercase',
            letterSpacing: '0.1px',
            color: basicTheme.palette.grey[100],
        },
    },

    components: {
        MuiTypography: {
            variants: [
                {
                    props: { variant: 'custom' },
                    style: customTypography,
                },
            ],

            defaultProps: {
                variantMapping: {
                    caption: 'p',
                    body2: 'p',
                },
            },
        },

        MuiButton: {
            styleOverrides: {
                root: ({ theme }) => ({
                    borderRadius: '8px',
                }),
            },

            variants: [
                {
                    props: { size: 'large' },
                    style: ({ theme }) => ({
                        padding: '13px 45px',
                        lineHeight: 1,
                    }),
                },
            ],
        },

        MuiPaper: {
            styleOverrides: {
                root: {
                    '&.MuiPopover-paper': {
                        boxShadow: '0px 0px 14px 0px rgba(0,0,0,0.1)',
                        borderRadius: '10px',
                    },

                    '&.MuiDialog-paper': {
                        borderRadius: '10px',
                    },
                },
            },
        },

        MuiChip: {
            styleOverrides: {
                root: () => ({
                    borderRadius: '6px',
                }),
            },

            variants: [
                {
                    props: { color: 'warning' },
                    style: ({ theme }) => ({
                        color: theme.palette.warning.main,
                        backgroundColor: alpha(theme.palette.warning.main, 0.1),

                        '&:hover': {
                            backgroundColor: alpha(theme.palette.warning.main, 0.2),
                            color: theme.palette.warning.main,
                        },
                    }),
                },

                {
                    props: { color: 'success' },
                    style: ({ theme }) => ({
                        color: theme.palette.success.main,
                        backgroundColor: alpha(theme.palette.success.main, 0.1),

                        '&:hover': {
                            backgroundColor: alpha(theme.palette.success.main, 0.2),
                            color: theme.palette.success.main,
                        },
                    }),
                },

                {
                    props: { size: 'small' },
                    style: () => ({
                        fontSize: '12px',
                        height: '24px',
                    }),
                },
            ],
        },
    },
})

export default theme
